import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { SettingsProvider } from "@/lib/settings";
import { PublicLayout } from "@/components/PublicLayout";

import HomePage from "@/pages/HomePage";
import PriceCalculatorPage from "@/pages/PriceCalculatorPage";
import WorksPage from "@/pages/WorksPage";
import { BlogPage, BlogDetailPage } from "@/pages/BlogPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminSimpleList from "@/pages/admin/AdminSimpleList";
import AdminFurnitureTypes from "@/pages/admin/AdminFurnitureTypes";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminHome from "@/pages/admin/AdminHome";

const wrap = (el) => <PublicLayout>{el}</PublicLayout>;

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            {/* Public */}
            <Route path="/" element={wrap(<HomePage />)} />
            <Route path="/fiyat-hesaplama" element={wrap(<PriceCalculatorPage />)} />
            <Route path="/calismalarimiz" element={wrap(<WorksPage />)} />
            <Route path="/blog" element={wrap(<BlogPage />)} />
            <Route path="/blog/:slug" element={wrap(<BlogDetailPage />)} />
            <Route path="/hakkimizda" element={wrap(<AboutPage />)} />
            <Route path="/iletisim" element={wrap(<ContactPage />)} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="quotes" element={<AdminQuotes />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="pricing" element={<AdminPricing />} />
              <Route path="furniture-types" element={<AdminFurnitureTypes />} />
              <Route path="colors" element={<AdminSimpleList
                title="Renkler" endpoint="colors" testidPrefix="colors"
                fields={[
                  { key: "name", label: "İsim", type: "text" },
                  { key: "hex", label: "Renk", type: "color" },
                  { key: "image_url", label: "Doku URL (opsiyonel)", type: "text" },
                ]}
              />} />
              <Route path="covers" element={<AdminSimpleList
                title="Kapak Türleri" endpoint="cover-types" testidPrefix="covers"
                fields={[
                  { key: "name", label: "İsim", type: "text" },
                  { key: "multiplier", label: "Fiyat Çarpanı", type: "number" },
                  { key: "tier", label: "Tier (standard/professional/both)", type: "text" },
                ]}
              />} />
              <Route path="legs" element={<AdminSimpleList
                title="Ayak Türleri" endpoint="leg-types" testidPrefix="legs"
                fields={[
                  { key: "name", label: "İsim", type: "text" },
                  { key: "extra_price", label: "Ek Ücret", type: "number" },
                  { key: "price_mode", label: "Fiyat Modu", type: "select", default: "per_m2",
                    options: [{ value: "flat", label: "Sabit (sipariş başına)" }, { value: "per_m2", label: "Metrekare başına (× m²)" }] },
                ]}
              />} />
              <Route path="handles" element={<AdminSimpleList
                title="Kulp Türleri" endpoint="handle-types" testidPrefix="handles"
                fields={[
                  { key: "name", label: "İsim", type: "text" },
                  { key: "extra_price", label: "Ek Ücret", type: "number" },
                  { key: "price_mode", label: "Fiyat Modu", type: "select", default: "per_m2",
                    options: [{ value: "flat", label: "Sabit (sipariş başına)" }, { value: "per_m2", label: "Metrekare başına (× m²)" }] },
                ]}
              />} />
              <Route path="testimonials" element={<AdminSimpleList
                title="Müşteri Yorumları" endpoint="testimonials" testidPrefix="testimonials"
                fields={[
                  { key: "name", label: "İsim", type: "text" },
                  { key: "role", label: "Rol / Sıfat", type: "text" },
                  { key: "content", label: "Yorum", type: "textarea" },
                  { key: "rating", label: "Puan (1-5)", type: "number" },
                  { key: "avatar", label: "Avatar URL", type: "text" },
                ]}
              />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="home" element={<AdminHome />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </div>
  );
}

export default App;
